var grandSavings = [
  {
    id: 1,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645503918/o2g7kme57zu6ob9nw6vm.png",
    name: "Zandu",
    link: "https://www.1mg.com/categories/ayurveda/top-brands/zandu-285",
  },
  {
    id: 2,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645503938/ozoyjywk9ah5yagoto8j.png",
    name: "Sri Sri Tattva",
    link: "https://www.1mg.com/categories/ayurveda/top-brands/sri-sri-tattva-536",
  },
  {
    id: 3,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645503952/osifrls0kgxwy2d49myw.png",
    name: "Dettol",
    link: "https://www.1mg.com/categories/featured/top-brands/dettol-288",
  },
  {
    id: 4,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645503965/zxcxrku0ylf2guywxprx.jpg",
    name: "Colgate",
    link: "https://www.1mg.com/categories/featured/colgate-828",
  },
  {
    id: 5,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645503984/ubnrb8jhzifkgutexd7g.png",
    name: "Fast &amp; Up",
    link: "https://www.1mg.com/categories/featured/top-brands/fast-up-791",
  },
  {
    id: 6,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645504001/qmjmxjryl4vdq2kbgw8o.jpg",
    name: "Durex",
    link: "https://www.1mg.com/categories/personal-care/sexual-wellness/durex-326",
  },
  {
    id: 7,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645504020/dikcpbbpucra4ota86j6.jpg",
    name: "Hansaplast",
    link: "https://www.1mg.com/categories/featured/top-brands/hansaplast-509",
  },
];

export default grandSavings;
